// SF-147 Component 8 re-homing table: shared pre-launch validation extracted from Attack.tsx's
// deleted handleLaunchAttack. Used by both War Room's commit bar (via useWarRoomState) and
// AmbushLaunchPanel's own submit handler. Ambush-source-specific validation (a source opportunity
// must be selected) is NOT here — it stays local to AmbushLaunchPanel, since it has no meaning for
// War Room's flow.

/**
 * Validates generals count and the soldiers-toggle-vs-composition invariant shared by both War
 * Room and Ambush's launch flows. Returns a human-readable error message, or `null` when valid.
 */
export function validateArmyComposition(params: {
  generals: number;
  soldiers: number;
  includeSoldiers: boolean;
}): string | null {
  if (params.generals < 1) {
    return 'Minimum 1 general required';
  }
  if (params.soldiers > 0 && !params.includeSoldiers) {
    return 'Must check "Include Soldiers" to send soldiers';
  }
  return null;
}
